import { render } from "./SystemTray.vue?vue&type=template&id=9af98960&scoped=true"
import script from "./SystemTray.vue?vue&type=script&lang=js"
export * from "./SystemTray.vue?vue&type=script&lang=js"

import "./SystemTray.vue?vue&type=style&index=0&id=9af98960&scoped=true&lang=scss"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9af98960"]])

export default __exports__